import { createContext } from "react";

export const ThemeContext = createContext()
export const ThemeFormContext = createContext()
export const ThemeReportContext = createContext()